<template>
  <div class="my-table editQueuePage">
    <!-- 面包屑组件 -->
    <div class="searchBox flexCenter">
      <div class="current-location">
        <img class="location" src="@/assets/picture/icon/location.png">
        <span>{{$t('editQueue.txt1')}}</span>
        <span>{{$t('editQueue.txt2')}} / {{$t('editQueue.txt3')}} / {{$t('editQueue.txt4')}}</span>
      </div>
      <div class="flexEnd">
        <div class="searchBtn ml20" @click="onBack">{{$t('editQueue.txt5')}}</div>
      </div>
    </div>
    <!-- 面包屑 -->
    <el-card class="tableCard p30">
      <div class="contactTitle flexCenter mb50">
        <span>{{$t('editQueue.txt4')}}</span>
        <div class="flexEnd">
          <div class="onCancelBtn mr30" @click="onBack">{{$t('editQueue.txt6')}}</div>
          <div class="searchBtn" @click="confirmAddQueue('dotParams')">{{$t('editQueue.txt7')}}</div>
        </div>
      </div>
      <div class="editForm editWidth">
        <el-form :model="dotParams"  ref="dotParams" label-width="100px" class="demo-ruleForm">
          <el-form-item :label="$t('editQueue.txt8')" prop="queueName">
            <el-input :placeholder="$t('editQueue.txt9')" v-model="dotParams.queueName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('editQueue.txt10')" prop="lanIp">
            <el-popover
            placement="bottom"
            width="300"
            v-model="hostVisible">
            <div class="handleBoxSeachQueue flexCenter">
              <el-input class="searchInput"
              :placeholder="$t('editQueue.txt11')"
              v-model="calculationName" @keypress.native.enter="getAllHost">
              
            </el-input>
            <img @click="getAllHost" class="searchIcon" src="@/assets/picture/icon/search_icon.png">
          </div>

         <!--    <el-input placeholder="请输入主机名称" v-model="calculationName" class="input-with-select">
              <el-button @click="getAllHost" slot="append" icon="el-icon-search"></el-button>
            </el-input> -->
           <!--  <el-checkbox :indeterminate="isIndeterminateHost" v-model="checkHostAll" @change="handleCheckAllHostChange">全选</el-checkbox> -->
            <div style="margin: 15px 0;"></div>
            <div class="checkBox">
              <el-checkbox-group v-model="checkHostList" @change="handlecheckHostChange">
                <div v-for="(item,index) in hostList" :key="index">
                  <el-checkbox :label="item.id">{{item.calculationName}}</el-checkbox>
                  <div class="cpuBox">
                    <span class="labelTxt">{{$t('editQueue.txt12')}}</span>
                    <el-slider v-model="item.cpus" @change="changeCpus(item)"></el-slider>
                    <span class="txt">
                      <el-input-number class="inputCpus" size="mini"  @change="changeCpus(item)" v-model="item.cpus"></el-input-number>
                    </span>
                  </div>
                </div>
              </el-checkbox-group>
            </div>
            <el-button class="inputBox" slot="reference">
              <span class="btnInput" style="color:#C2C6CD;" v-if="checkedhostList.length == 0">{{$t('editQueue.txt13')}}</span>
              <span class="btnInput" style="color:#333;"  v-if="checkedhostList.length > 0">{{calculationName}}</span>
              <!-- <div v-if="checkedhostList.length > 0" style="display: flex;">
                <div v-for="(item,index) in checkedhostList" :key="index">
                  <span>{{item}}</span>
                  <span v-if="index!=checkedhostList.length-1">,</span>
                </div>
              </div> -->
            </el-button>
          </el-popover>
        </el-form-item>
        <el-form-item :label="$t('editQueue.txt14')" prop="projects">
          <el-select v-model="dotParams.projects" multiple :placeholder="$t('editQueue.txt26')">
            <el-option
            v-for="item in projectList"
            :key="item.id"
            :label="item.projectName"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('editQueue.txt15')">
        <el-popover
        placement="bottom"
        width="300"
        v-model="userVisible">
        <div class="handleBoxSeachQueue flexCenter">
         <el-input class="searchInput"
         :placeholder="$t('editQueue.txt16')"
         v-model="name" @keypress.native.enter="getAllUser"> 
       </el-input>
       <img slot="append" @click="getAllUser" class="searchIcon" src="@/assets/picture/icon/search_icon.png">
     </div>

       <!--  <el-input placeholder="请输入用户名称" v-model="name" class="input-with-select">
          <el-button @click="getAllUser" slot="append" icon="el-icon-search"></el-button>
        </el-input> -->
     <!--    <el-checkbox :indeterminate="isIndeterminateUser" v-model="checkUserAll" @change="handleCheckAllUserChange">全选</el-checkbox> -->
        <div style="margin: 15px 0;"></div>
        <div class="checkBox userBox">
          <el-checkbox-group v-model="checkUserList" @change="handlecheckUserChange">
            <div v-for="(item,index) in userList" :key="index">
              <el-checkbox :label="item.value">{{item.label}}</el-checkbox>
            </div>
          </el-checkbox-group>
        </div>
        <el-button class="inputBox" slot="reference">
          <span style="color:#C2C6CD;" class="btnInput" v-if="checkedUserList.length == 0">{{$t('editQueue.txt17')}}</span>
          <span style="color:#333;" class="btnInput" v-if="checkedUserList.length > 0">{{name}}</span>
              <!-- <div v-if="checkedUserList.length > 0" style="display: flex;">
                <div v-for="(item,index) in checkedUserList" :key="index">
                  <span>{{item}}</span>
                  <span v-if="index!=checkedUserList.length-1">,</span>
                </div>
              </div> -->
            </el-button>
          </el-popover>
        </el-form-item>
      </el-form>
    </div>
  </el-card>
</div>
</template>

<script>
  import qs from 'qs';
  export default {
    data() {
      const generateData = _ => {
        const userList = [];
        for (let i = 1; i <= userList.length; i++) {
          userList.push({
            key: userList[i].value,
            label: userList[i].label,
          });
        }
        return userList;
      };
      return {
        checkHostAll:false,
        checkUserAll: false,
        hostList:[],
        projectList:[],
        calculations:[],
        userInfos:[],
        projects:[],
        isIndeterminateHost:true,
        userList: generateData(),//所有用户
        userVisible:false,
        checkHostList:[],
        checkedhostList:[],//被选择的主机
        checkUserList:[],
        checkedUserList:[],//被选择的用户
        calculationName:'',//搜索主机名称
        isIndeterminateUser: true,
        name:'',//搜索用户名
        hostVisible:false,
        dotParams:{
          id:"",
          desktopName:"",
          lanIp:"",
          wanIp:"",
          desktopPort:"",
          desktopUrl:"",
          desktopDescribe:"",
          userInfos:[],
          online:true,
          state: 1
        },//添加队列参数
        // 添加队列规则
        addDotRules: {
          desktopName: [
          { required: true, message: this.$t('editQueue.txt18'), trigger: 'blur' },
          { pattern: /^[a-zA-Z]{1}\w*$/, message: this.$t('editQueue.txt19') },
          ],
          lanIp:[
          { required: true, message: this.$t('editQueue.txt20'), trigger: 'blur' },
          { pattern: /^((2[0-4]\d|25[0-5]|[01]?\d\d?)\.){3}(2[0-4]\d|25[0-5]|[01]?\d\d?)$/, message: this.$t('editQueue.txt21') },
          ],
          wanIp:[
          { required: true, message: this.$t('editQueue.txt22'), trigger: 'blur' },
          { pattern: /^(?=^.{3,255}$)[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+$/, message: this.$t('editQueue.txt23') },
          ],
          desktopPort:[
          { required: true, message: this.$t('editQueue.txt24'), trigger: 'blur' },
          { pattern: /^([1-9]|[1-5]\d{4}|6[1-4]\d{3}|65[1-4]\d{2}|655[1-2]\d|6553[1-5])$/, message: this.$t('editQueue.txt25') },
          ],
        },
      };
    },
    created() {
      this.getAllUser();
      this.getAllHost();
      this.getAllProject();
      this.dotParams.id = this.$route.query.id?this.$route.query.id:'';
      if(this.dotParams.id){
        this.getQueueInfo();
      }
    },

    methods: {
      onBack(){
        this.$router.go(-1);
      },
      // 获取所有用户
      async getAllUser() {
        let data = {
          name: this.name
        }
        const {data: res} = await this.$http.post("/user/info/list/all?"+qs.stringify(data));
        if (!res.success) {
          return this.$message.error(res.message);
        }
        let list = res.result;
        this.userList = [];
        list.map(e=>{
          let item = {
            value:e.id,
            label:e.userName,
            realName:e.userName
          }
          this.userList.push(item);
        })
      },
      // 队列详细
      async getQueueInfo() {
        let data = {
          queueId: this.dotParams.id
        }
        const {
          data: res
        } = await this.$http.post("/calculation/queue/getQueueInfo?"+qs.stringify(data));
        if (!res.success) {
          return this.$message.error(res.message);
        }
        this.dotParams = res.result;
        this.calculationName = '';
        this.checkedhostList = [];
        this.checkHostList = [];
        if(this.dotParams.queueCalculationCpu && this.dotParams.queueCalculationCpu.length>0){
          this.dotParams.queueCalculationCpu.map(e=>{
            this.checkHostList.push(e.calculationId);
            let item = {
              calculationName:e.calculationName,
              cpus:e.cpus,
              id:e.calculationId
            }
            this.calculations.push(item);
            this.checkedhostList.push(e.calculationName);
          })
        }
        this.calculationName = this.checkedhostList.join(",");
        this.checkedUserList = [];
        this.checkUserList = [];
        this.name = '';
        if(this.dotParams.userInfos && this.dotParams.userInfos.length>0){
          this.dotParams.userInfos.map(e=>{
            this.checkUserList.push(e.id);
            this.checkedUserList.push(e.userName);
          })
        }
        this.name = this.checkedUserList.join(",");
        if(res.result.projects && res.result.projects.length>0){
          let arr = [];
          res.result.projects.map((e,i)=>{
              arr.push(e.id);
          })
          this.dotParams.projects = arr;
        }
        // this.handlecheckHostChange(this.checkUserList);
      },
      // 获取所有主机
      async getAllHost() {
        let data = {
          calculationName : this.calculationName
        }
        const {data: res} = await this.$http.post("/calculation/list?"+qs.stringify(data));
        if (!res.success) {
          return this.$message.error(res.message);
        }
        this.hostList = res.result;
        if(this.hostList && this.hostList.length>0 && this.calculations && this.calculations.length){
          for( var j = 0; j < this.hostList.length; j ++ ) {
              for( var i = 0; i < this.calculations.length; i++ ) {
                  if( this.calculations[i].id == this.hostList[j].id ) {
                      this.hostList[j].cpus = this.calculations[i].cpus;
                  }
              }
          }
        }
        
      },
      // 获取所有项目
      async getAllProject() {
        const {data: res} = await this.$http.post("/project/list/all");
        if (!res.success) {
          return this.$message.error(res.message);
        }
        this.projectList = res.result;
      },
      // 添加编辑队列操作
      confirmAddQueue(formName) {
       this.$refs[formName].validate((valid) => {
         if (valid) {
           this.edit();
         } else {
           console.log('error submit!!');
           return false;
         }
       });
     },
     async edit() {
      if(this.dotParams.projects.length>0 ){
        this.projects = [];
        this.projectList.map(e=>{
          this.dotParams.projects.map(i=>{
            if(e.id == i){
              let item = {
                id:e.id,
                projectName:e.projectName
              }
              this.projects.push(item);
            }
          })
        })
      }
      // this.dotParams.calculations = this.calculations;
      let arr = [];
      if(this.checkUserList && this.checkUserList.length>0){
        if(this.checkUserList && this.checkUserList.length>0){
          this.checkUserList.map(e=>{
            let item = {
              id:e
            }
            arr.push(item);
          })
        }
      }
      this.dotParams.userInfos = arr;
      // this.dotParams.projects = this.projects;
      let data = {
        ...this.dotParams,
        calculations:this.calculations,
        projects:this.projects
      }
      const {data: res} = await this.$http.post("/calculation/queue/add",data);
      if(res.success){
        this.$message({
          message: res.message,
          type: 'success'
        });
        this.$router.go(-1);
      }else{
        return this.$message.error(res.message);
      }
    },
      // 用户全选
      handleCheckAllUserChange(val) {
        this.checkUserList = val ? this.userList : [];
        this.isIndeterminateUser = false;
      },
      // 用户单选
      handlecheckUserChange(value) {
        let checkedCount = value.length;
        this.checkUserAll = checkedCount === this.userList.length;
        this.isIndeterminateUser = checkedCount > 0 && checkedCount < this.userList.length;
        this.userInfos = [];
        this.checkedUserList = [];
        this.userList.map(e=>{
          this.checkUserList.map(i=>{
            if(e.value == i){
              this.checkedUserList.push(e.label);
              let item = {
                id:e.value,
                realName:e.userName
              }
              this.userInfos.push(item);
            }
          })
        })
        this.name = this.checkedUserList.join(",");
      },
      // 主机全选
      handleCheckAllHostChange(val) {
        this.checkHostList = val ? this.hostList : [];
        this.isIndeterminateHost = false;
      },
      // 主机单选
      handlecheckHostChange(value) {
        let checkedCount = value.length;
        this.checkHostAll = checkedCount === this.hostList.length;
        this.isIndeterminateHost = checkedCount > 0 && checkedCount < this.hostList.length;
        this.checkedhostList = [];
        this.calculations = [];
        this.hostList.map(e=>{
          this.checkHostList.map(i=>{
            if(e.id == i){
              let item = {
                id:e.id,
                calculationName:e.calculationName,
                cpus:e.cpus
              }
              this.calculations.push(item);
              this.checkedhostList.push(e.calculationName);
            }
          })
        })
        this.calculationName = this.checkedhostList.join(",");
      },
      // 更改cpus数量      
      changeCpus(item){
        let calculationsList = this.calculations;
        if(calculationsList && calculationsList.length>0){
          calculationsList.map(e=>{
            if(e.id == item.id){
              e.cpus = item.cpus;
            }
          })
        }
      }
    },
  };
</script>

<style lang="less" scoped>

  .handleBtn{
    padding: 0;
  }
  .editQueuePage{
   .inputBox{
    height: 36px;
    line-height: 36px;
    width: 100%;
    background: #F4F4F4;
    border: none;
    border-radius: 18px;
    padding: 0;
    text-align: left;
    padding-left: 25px;
    font-size: 14px;
  }
  /deep/ .el-select{
    width: 100%;
  }
  /deep/ .el-input-group--append{
   height: 36px;
   line-height: 36px;
   width: 100%;
   background: #F4F4F4;
   border: none;
   border-radius: 18px;
   padding: 0;
   text-align: left;
   padding-left: 25px;
 }
 /deep/ .el-slider__button-wrapper{
  top:-16px;
 }
 /deep/ .el-input-group__append{
  padding: 0 !important;
}
/*  /deep/ .el-input-group__append button.el-button{
    padding:0;
    width: auto;
    margin-right: 1.1rem;
  }*/
  /deep/ .el-upload__input{
    display: none !important;
  }
  /deep/ .el-date-editor .el-range-separator{
    margin-top: -5px;
    width: 8%;
  }
  .contactTitle{
    margin-bottom: 40px;
  }
  .contactTitle span{
    margin-right: 30px;
    cursor: pointer;
    font-size: 30px;
    font-weight: 500;
    color: #222222;
  }
  .w350{
    width: 350px;
  }
  .searchUserBox{
    /*width: 33.6rem !important;*/
    height: 3.2rem;
    margin-bottom: 3rem;
    /deep/ .el-input__inner{
      border:1px solid #C0C0C0;
      border-right:none;
    }
  }
  /deep/ .input-with-select{
    margin-bottom: 20px;
  }
  .tips{      
    font-size: 1.4rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #98B9FF;
    margin-top: -10px;
  }
  .editForm{}
  /deep/  .el-date-table td.today span{
    color: #fff;
    background: #1B3B7C;
    border-radius: 100%;
  }
  /deep/ .el-date-table td.end-date span,/deep/ .el-date-table td.start-date span{
    background: #1B3B7C !important;
  }

}

</style>
